<div mat-dialog-title>
  <span i18n>Мастер установки выреза</span>

  <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding ps flex flex-col">
  <mat-horizontal-stepper [linear]="true" #stepper class="w-full h-full overflow-auto">
    <mat-step #schemaListStep [completed]="false" [editable]="false">
      <ng-template i18n matStepLabel>Выберите шаблон выреза</ng-template>

      <mat-divider></mat-divider>

      <csl-standard-cutouts
        [groupId]="data.material.inMaterialBaseGroupId"
        (selectChanged)="standardSelectChange($event)"
        cslPerfectScrollbar>
      </csl-standard-cutouts>
    </mat-step>

    <mat-step [completed]="false" [editable]="false" #adderStep>
      <ng-template i18n matStepLabel>Добавьте вырез</ng-template>

      <mat-divider></mat-divider>

      <csl-cutout-adder #cutoutAdder [countertop]="data"></csl-cutout-adder>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<div mat-dialog-actions>
  <button i18n mat-raised-button color="accent" (click)="dialogRef.close(getCoord())" [disabled]="isInvalid$ | async"
    >ОК</button
  >
  <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
</div>
